import styles from '@components/components/EnergieSparCheck/WarmWasserCheck/FinalStep.module.scss';
import Container from '@components/components/Container/Container';
import classNames from 'classnames';
import {
  BlogCard,
  Button,
  Card,
  CardBody,
  Content,
  FontAwesomeProIcon,
  Heading,
  Link,
} from '@wienenergiegithub/ui-next';
import React from 'react';

const TotalPercentageText = ({ percentage }) => {
  if (percentage > 0) {
    return (
      <Heading as="div" className={styles.red} noSpacing size="h1">
        ca. {Math.abs(percentage)} % über dem Durchschnitt
      </Heading>
    );
  }
  return (
    <Heading as="div" className={styles.green} noSpacing size="h1">
      ca. {Math.abs(percentage)} % unter dem Durchschnitt
    </Heading>
  );
};

const FinalStep = ({
  mainPosts,
  verbrauch,
  percentage,
  isFernwärme,
  blogLink,
}) => {
  const ending = isFernwärme ? 'Liter/m<sup>3</sup>' : 'kWh';
  const ariaLabel = isFernwärme ? 'Kubikmeter' : 'Kilowattstunden';
  const [resultsWithPost] = mainPosts;

  return (
    <div className={styles.container}>
      <Container size="lg">
        <div className={classNames(styles.row, styles.titleRowMargin)}>
          <div className={classNames(styles.column, styles.noGap)}>
            <Heading
              as="h2"
              className={styles.smallSpacing}
              role="status"
              size="h2"
            >
              Ihr Ergebnis
            </Heading>
            <Content noSpacing>
              Ihr Ergebnis ist ein ungefährer Durchschnittswert Ihres
              Wasserverbrauchs. Er soll Ihnen ein Gefühl dafür vermitteln, ob
              Ihr Verbrauch hoch oder niedrig ist. Wenn Ihr Verbrauch hoch ist,
              sehen Sie sich doch gleich mal unsere Tipps an, wie Sie aktiv
              Wasser sparen können.
            </Content>
          </div>
        </div>
        <div className={styles.firstRow}>
          <Card className={styles.factCard}>
            <CardBody>
              <Heading as="h3" className={styles.smallSpacing} size="h4">
                Ihr aktueller Gesamtverbrauch
              </Heading>
              <TotalPercentageText percentage={percentage} />

              <Content className={styles.legal} noSpacing>
                Alle Berechnungen basieren auf durchschnittlichen
                Verbrauchswerten.
              </Content>
            </CardBody>
          </Card>
        </div>
        <div className={styles.row}>
          <div className={styles.column}>
            <Card className={styles.factCard}>
              <CardBody>
                <Heading
                  as="h4"
                  className={styles.smallSpacing}
                  noSpacing
                  size="h5"
                >
                  Ungefährer Verbrauch
                </Heading>
                <Heading
                  aria-label={`${verbrauch} ${ariaLabel}`}
                  as="div"
                  className={styles.usageHeading}
                  size="h1"
                  withParser
                >
                  {`${verbrauch.toLocaleString('de')} ${ending}`}
                </Heading>
                <Content className={styles.legal} noSpacing>
                  {isFernwärme
                    ? 'Wir geben Ihren Warmwasserverbauch in Liter/m³ an, weil Ihr Fernwärmezähler nur in Liter/m³ misst und Ihr Verbrauch auf Ihrer Abrechnung auch in dieser Einheit angegeben wird.'
                    : 'Wenn Sie Ihr Warmwasser mit Strom bzw. Erdgas aufbereiten, sehen Sie auf Ihrer Abrechnung den Warmwasserverbrauch in kWh angegeben. Daher stellen wir unser Ergebnis auch in kWh dar.'}
                </Content>
              </CardBody>
            </Card>
            <Card className={styles.factCard}>
              <CardBody>
                <Heading as="h4" size="h5">
                  Sparen Sie Warmwasserkosten
                </Heading>
                <div className={styles.tippRow}>
                  <div className={styles.tipps}>
                    <FontAwesomeProIcon
                      className={styles.icon}
                      icon="faucet"
                      size="2x"
                    />
                    <Heading as="p" noSpacing size="h5">
                      Bis zu 50 %
                    </Heading>
                    <Content className={styles.tipSubText} noSpacing>
                      Energie einsparen mit dem Geschirrspüler im Vergleich zum
                      Abwaschen per Hand.
                    </Content>
                  </div>
                  <div className={styles.tipps}>
                    <FontAwesomeProIcon
                      className={styles.icon}
                      icon="droplet"
                      size="2x"
                    />
                    <Heading as="p" noSpacing size="h5">
                      Bis zu 30 %
                    </Heading>
                    <Content className={styles.tipSubText} noSpacing>
                      Kosten einsparen mit einem Sparduschkopf im Vergleich zu
                      einem normalen Duschkopf.
                    </Content>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
          <div className={styles.column}>
            {resultsWithPost && (
              <BlogCard
                target="_blank"
                {...resultsWithPost}
                className={styles.blogCard}
              />
            )}
          </div>
        </div>
        <div className={styles.finalRow}>
          <Content align="center" noSpacing>
            Sie wollen Ihr Energiespar-Potenzial bis ins Detail kennen und
            umsetzen? Dann holen Sie sich das Expertenwissen unserer
            Energieberater*innen.
          </Content>
          {blogLink?.url && (
            <Button
              render={
                <Link className={styles.button} to={blogLink.url}>
                  {blogLink.title}
                </Link>
              }
              variant="outline"
            />
          )}
        </div>
      </Container>
    </div>
  );
};

export default FinalStep;
